import { MutationKey } from '@shared/config';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { ChatOutgoingPayload } from '@packages/chat/react';
import { userApi } from '../userApi';
import { userAiMessageQueryKeys } from './useListUserAiMessages';

export const useSendUserAiMessage = (userId: number | undefined) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [MutationKey.SEND_USER_AI_MESSAGE, userId],
    mutationFn: (payload: ChatOutgoingPayload) => {
      if (userId == null) {
        return Promise.reject(new Error('userId is required'));
      }
      return userApi.sendUserAiMessage(
        String(userId),
        payload.data,
        payload.type
      );
    },
    // The chat shows the sent message locally until a refresh returns it.
    onSettled: () => {
      void queryClient.invalidateQueries({
        queryKey: userAiMessageQueryKeys.latestRoot(userId),
      });
      void queryClient.invalidateQueries({
        queryKey: userAiMessageQueryKeys.historyRoot(userId),
      });
    },
  });
};
